import {ERROR_STATUS} from './consts';

export const getErrorStatusCode = error => error?.status ?? ERROR_STATUS.SOMETHING_WENT_WRONG;
